/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Age_Min_OnlyInputs */

const th_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อายุ ${i?.min} ปีขึ้นไป`)
};

const en_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ages ${i?.min} and up`)
};

const ja_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}歳以上`)
};

const zh_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 岁以上`)
};

const es_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A partir de ${i?.min} años`)
};

const pt_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A partir de ${i?.min} anos`)
};

const id_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} tahun ke atas`)
};

const fr_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`À partir de ${i?.min} ans`)
};

const tl_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} taong gulang pataas`)
};

const vi_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.min} tuổi trở lên`)
};

const ko_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}세 이상`)
};

const de_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ab ${i?.min} Jahren`)
};

const ru_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`От ${i?.min} лет`)
};

const tr_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} yaş ve üzeri`)
};

const it_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Da ${i?.min} anni in su`)
};

const pl_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.min} lat`)
};

const uk_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Від ${i?.min} років`)
};

const hi_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} वर्ष और उससे अधिक`)
};

const ar_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} سنة فأكثر`)
};

const ms_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} tahun ke atas`)
};

const bn_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} বছর ও তার বেশি`)
};

const zh_tw2_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 歲以上`)
};

const zh_hk2_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 歲以上`)
};

const ur_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} سال اور اس سے زیادہ`)
};

const fa_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} سال به بالا`)
};

const sw_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miaka ${i?.min} na zaidi`)
};

const nl_age_min_only = /** @type {(inputs: Age_Min_OnlyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} jaar en ouder`)
};

/**
* | output |
* | --- |
* | "Ages {min} and up" |
*
* @param {Age_Min_OnlyInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const age_min_only = /** @type {((inputs: Age_Min_OnlyInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Age_Min_OnlyInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_age_min_only(inputs)
	if (locale === "ja") return ja_age_min_only(inputs)
	if (locale === "zh") return zh_age_min_only(inputs)
	if (locale === "es") return es_age_min_only(inputs)
	if (locale === "pt") return pt_age_min_only(inputs)
	if (locale === "id") return id_age_min_only(inputs)
	if (locale === "fr") return fr_age_min_only(inputs)
	if (locale === "tl") return tl_age_min_only(inputs)
	if (locale === "vi") return vi_age_min_only(inputs)
	if (locale === "ko") return ko_age_min_only(inputs)
	if (locale === "de") return de_age_min_only(inputs)
	if (locale === "ru") return ru_age_min_only(inputs)
	if (locale === "tr") return tr_age_min_only(inputs)
	if (locale === "it") return it_age_min_only(inputs)
	if (locale === "pl") return pl_age_min_only(inputs)
	if (locale === "uk") return uk_age_min_only(inputs)
	if (locale === "hi") return hi_age_min_only(inputs)
	if (locale === "ar") return ar_age_min_only(inputs)
	if (locale === "ms") return ms_age_min_only(inputs)
	if (locale === "bn") return bn_age_min_only(inputs)
	if (locale === "zh-TW") return zh_tw2_age_min_only(inputs)
	if (locale === "zh-HK") return zh_hk2_age_min_only(inputs)
	if (locale === "ur") return ur_age_min_only(inputs)
	if (locale === "fa") return fa_age_min_only(inputs)
	if (locale === "sw") return sw_age_min_only(inputs)
	if (locale === "nl") return nl_age_min_only(inputs)
	return en_age_min_only(inputs)
});